// rainModeBus.ts
// ==============
//
// Wave 14ca-fix64: Rain-Mode (Display-Lock gegen Regentropfen).
//
// Kapazitive Touchscreens interpretieren Wassertropfen als Berührungen.
// Beim Regenfahren (oder Splash unterm Schutzblech) führt das zu zufaelligem
// Pan/Zoom/Trail-Tap — die App ist im Wesentlichen unbedienbar. Garmin loest
// das mit Hardware-Lock-Buttons; wir haben in einer PWA keine Hardware-API,
// aber wir koennen Software-seitig alle Touches schlucken bis eine bewusste
// Geste den Lock aufhebt.
//
// Entsperrungs-Geste: 3 Finger gleichzeitig fuer 2 Sekunden gehalten.
//   - 3 Finger weil Wassertropfen typisch 1, hoechstens 2 "Touchpunkte"
//     erzeugen. Drei gleichzeitige stabile Punkte sind physikalisch nur
//     durch absichtliche Berührung moeglich.
//   - 2 Sekunden weil ein versehentlicher kurzer 3-Finger-Touch (z.B. beim
//     Handy-aus-der-Tasche-Holen) sonst entsperren koennte. 2 s ist lang
//     genug fuer "Intent", kurz genug um nicht nervig zu sein.
//
// Aktivierungs-Pfade:
//   - Button im ZoomButtons-Stack (🌧️) — Tap aktiviert sofort
//   - In Zukunft eventuell automatisch via Wetter-API oder Wasser-Detektion
//
// Recording laeuft im Lock weiter — der User sieht weiterhin km/hm und das
// Hoehenprofil-Strip, kann nur nichts mehr antippen. Stop-Button bleibt
// nicht klickbar — bewusst, weil der User sonst unbeabsichtigt stoppt.
// Zum Stoppen muss er erst entsperren.

type Listener = (active: boolean) => void;

class RainModeBus {
  private active = false;
  private readonly listeners = new Set<Listener>();

  get(): boolean {
    return this.active;
  }

  activate(): void {
    if (this.active) return;
    this.active = true;
    this.notify();
  }

  deactivate(): void {
    if (!this.active) return;
    this.active = false;
    this.notify();
  }

  toggle(): void {
    this.active = !this.active;
    this.notify();
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify(): void {
    for (const l of this.listeners) l(this.active);
  }
}

export const rainModeBus = new RainModeBus();
